import { render, staticRenderFns } from "./loanReviewDetails.vue?vue&type=template&id=6afcb931&scoped=true&"
import script from "./loanReviewDetails.vue?vue&type=script&lang=js&"
export * from "./loanReviewDetails.vue?vue&type=script&lang=js&"
import style0 from "./loanReviewDetails.vue?vue&type=style&index=0&id=6afcb931&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afcb931",
  null
  
)

export default component.exports